import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css'
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reducers from './reducers';
var store = createStore(reducers);
const root = ReactDOM.createRoot(document.getElementById('rslStoreLocator'));
// document.getElementById('rslStoreLocator').setAttribute('data-map_id', 179);
root.render(
<Provider store={store}>
    <App />
    </Provider>
    );